import { Draft, produce } from 'immer';

import { FeatureType } from '@app/features/subscription/types/FeatureType';
import { USER_AUTHORITY__FETCH_SUCCESS, USER_AUTHORITY__INITIALIZE } from '@app/store/actionTypes';
import { UserAuthorityAction } from '@app/store/user/authority/actions';

export type UserAuthorityUsagesState = {
  [K in FeatureType]: {
    count: number;
    feature: K;
  };
};

const initialState: UserAuthorityUsagesState = {
  [FeatureType.API_SIGNING_REQUEST_COUNT]: {
    count: 0,
    feature: FeatureType.API_SIGNING_REQUEST_COUNT,
  },
  [FeatureType.ATTACHMENT_REQUEST_COUNT]: {
    count: 0,
    feature: FeatureType.ATTACHMENT_REQUEST_COUNT,
  },
  [FeatureType.BULK_REQUEST_COUNT]: {
    count: 0,
    feature: FeatureType.BULK_REQUEST_COUNT,
  },
  [FeatureType.CONTRACT_LINK_COMPLETED_DOCUMENT_COUNT]: {
    count: 0,
    feature: FeatureType.CONTRACT_LINK_COMPLETED_DOCUMENT_COUNT,
  },
  [FeatureType.DOCUMENT_COUNT]: {
    count: 0,
    feature: FeatureType.DOCUMENT_COUNT,
  },
  [FeatureType.EXTERNAL_DOCUMENT_COUNT]: {
    count: 0,
    feature: FeatureType.EXTERNAL_DOCUMENT_COUNT,
  },
  [FeatureType.KAKAO_NOTIFICATION_COUNT]: {
    count: 0,
    feature: FeatureType.KAKAO_NOTIFICATION_COUNT,
  },
  [FeatureType.MOBILE_VERIFICATION_COUNT]: {
    count: 0,
    feature: FeatureType.MOBILE_VERIFICATION_COUNT,
  },
  [FeatureType.WORKSPACE_SEAT_COUNT]: {
    count: 0,
    feature: FeatureType.WORKSPACE_SEAT_COUNT,
  },
  [FeatureType.SIGNING_REQUEST_COUNT]: {
    count: 0,
    feature: FeatureType.SIGNING_REQUEST_COUNT,
  },
  [FeatureType.TEMPLATE_COUNT]: {
    count: 0,
    feature: FeatureType.TEMPLATE_COUNT,
  },
  [FeatureType.SIGNER_COUNT]: {
    count: 0,
    feature: FeatureType.SIGNER_COUNT,
  },
};

const reducer = produce((draft: Draft<UserAuthorityUsagesState>, action: UserAuthorityAction) => {
  switch (action.type) {
    case USER_AUTHORITY__FETCH_SUCCESS: {
      Object.values(FeatureType).forEach((key) => {
        draft[key].count = 0;
      });
      if (action.payload) {
        const { usages } = action.payload;
        usages.forEach(({ count, feature }) => {
          if (feature in draft) {
            draft[feature].count = count;
            draft[feature].feature = feature;
          }
        });
      }
      return draft;
    }
    case USER_AUTHORITY__INITIALIZE:
      return initialState;
    default:
      return draft;
  }
}, initialState);

export default reducer;
